import { Game } from "api/active-games/get-active-games";

export const isCurrentPlayersTurn = (game: Game, currentUserId: string) => {
  return game.currentDecisions.some((decision) => decision.UserId === currentUserId);
};
